<template>
  <div>
    <v-card class="scoring-debug" v-if="debug">
      <v-card-text>
        <table v-if="categories">
          <tr v-for="(item, i) in categories" :key="i">
            <th>{{ item.display }}:</th>
            <td class="pl-2">{{ item.control_value }}</td>
          </tr>
        </table>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="headers"
      :items-per-page="20"
      :items="categories"
      hide-default-footer
      disable-sort
      class="standard-table"
    >
      <template v-slot:[`item`]="{ item }">
        <tr class="standard-table-row">
          <td class="standard-table-td">{{ item.display }}</td>
          <td class="standard-table-td">
            <v-text-field
              v-if="item.control_type === 'txt'"
              class="dynamic-input-control dense"
              label="Vložte hodnotu"
              solo
              v-model="item.control_value"
              outlined
              dense
              hide-details
            />
            <v-autocomplete
              v-else-if="item.control_type === 'cb'"
              :items="item.children"
              placeholder="Zvoľte typ"
              dense
              class="dynamic-input-control dense"
              outlined
              hide-details
              item-text="display_member"
              item-value="value_member"
              v-model="item.control_value"
              clearable
            />
            <DatePicker
              class="mb-n8px"
              v-else-if="item.control_type === 'dt'"
              dense
              hide-error-icon
              placeholder="DD/MM/YYYY"
              v-model="item.control_value"
              :key="item.control_type"
            />
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import Utils from '../../plugins/utils';
import protectedAxios from '../../auth/axios';
import DatePicker from '../basic/DatePicker.vue';
import { mapGetters } from 'vuex';

export default {
  props: {
    show: Boolean,
    variant: Object,
    scoringData: Array,
  },
  components: {
    DatePicker,
  },
  computed: {
    ...mapGetters(['debug']),
  },
  watch: {
    show(val) {
      this.l_show = val;
    },
    scoringData(data) {
      this.categories = [];
      if (data) {
        let categoriesList = Utils.groupBy(
          data,
          datum => datum.id_category,
          datum => datum.category
        );
        this.categories = categoriesList.map(c => {
          return {
            key: c.key,
            display: c.display,
            children: c.children.filter(ch => ch.value_member !== null),
            control_type: c.children.length > 0 ? c.children[0].control_type : null,
            control_value:
              c.children.length > 0 && c.children[0].control_value
                ? parseInt(c.children[0].control_value)
                : null,
            combo_key: Math.random().toString(36).substring(2, 7),
          };
        });

      }
    },
  },
  data() {
    return {
      l_show: null,
      categories: [],
      headers: [
        { text: 'Kategória', value: 'display' },
        { text: 'Hodnota', value: 'children', width: 350 },
      ],
    };
  },
  methods: {
    save() {
      if (!this.variant) return Promise.resolve(true);
      let parameters = this.categories.map(c => {
        let value = !c.control_value && c.control_value != 0 ? null : String(c.control_value);
        //datepicker vracia yyyy-mm-dd cize treba odpalit pomlcky
        if (value && c.control_type === 'dt') value = value?.replace(/-/g, '');
        return {
          id: c.key,
          value,
        };
      });
      return protectedAxios
        .post(
          `sumar/scoring`,
          {
            cisloPlz: this.variant.cislo_plz,
            scoringParameters: parameters,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then(() => {
          return this.variant;
        });
    },
  },
};
</script>
<style lang="sass">
.scoring-debug
  position: fixed
  left: 0
  top: 80px
</style>
